import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { setAuthToken } from '../utils/auth';
import Verification from './Verification';

/**
 * This component is responsible for handling token URLs and redirecting properly
 */
const TokenRedirect: React.FC = () => {
  const [message, setMessage] = useState('Processing your verification link...');
  const [tokenValid, setTokenValid] = useState(false);
  const { token } = useParams<{ token: string }>();
  
  useEffect(() => {
    // Handle token extraction without redirecting
    const processToken = () => {
      try {
        if (token) {
          console.log(`Token found in URL: ${token.substring(0, 10)}...`);
          
          // Basic validation - checking if it's a JWT token
          if (token.length > 100 && token.includes('.')) {
            // Store token
            setAuthToken(token);
            console.log('Token saved to localStorage');
            
            // Token is valid, show verification component
            setTokenValid(true);
          } else {
            setMessage('Invalid token format. Please check your verification link.');
          }
        } else {
          setMessage('No token found in URL. Please check your verification link.');
        }
      } catch (error) {
        console.error('Error processing token:', error);
        setMessage('Error processing your verification link. Please try again later.');
      }
    };
    
    // Execute immediately - no need for delay
    processToken();
  }, [token]);
  
  // If token is valid, render the Verification component directly
  if (tokenValid) {
    return <Verification />;
  }
  
  // Otherwise show loading/error state
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 border-4 border-t-primary-500 border-primary-100 rounded-full animate-spin"></div>
        </div>
        <h2 className="text-xl font-medium text-center text-gray-900 mb-2">
          {message}
        </h2>
        <p className="text-gray-600 text-center">
          Please wait while we process your verification link...
        </p>
      </div>
    </div>
  );
};

export default TokenRedirect;